import { render, staticRenderFns } from "./collectionAvgTaskInfo.vue?vue&type=template&id=49711344&scoped=true"
import script from "./collectionAvgTaskInfo.vue?vue&type=script&lang=js"
export * from "./collectionAvgTaskInfo.vue?vue&type=script&lang=js"
import style0 from "./collectionAvgTaskInfo.vue?vue&type=style&index=0&id=49711344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49711344",
  null
  
)

export default component.exports